import { createFileRoute, Outlet } from '@tanstack/react-router';
import { User } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/org-settings/users')({
    staticData: {
        breadcrumb: { title: 'Team management' },
        ui: { icon: User },
        permissions: ['user:read', 'user:update'],
    },
    component: Outlet,
});
